module.exports = __webpack_public_path__ + "img/product_info_header.40b8c8a1.jpg";